import http from './http';

export default {
  // 获取题库列表
  getList(params) {
    return http.get('/o1/question_bank/index', params);
  },

  // 获取题库详情
  getDetail(id) {
    return http.get('/o1/question_bank/read', { id });
  },

  // 创建题库
  create(data) {
    return http.post('/o1/question_bank/save', data);
  },

  // 更新题库
  update(data) {
    return http.post('/o1/question_bank/save', data);
  },

  // 删除题库
  delete(id) {
    return http.post('/o1/question_bank/delete', { id });
  },

  // 批量删除题库
  batchDelete(ids) {
    return http.post('/o1/question_bank/batch_delete', { ids });
  },

  // 获取题库统计信息
  getStatistics() {
    return http.get('/o1/question_bank/statistics');
  },

  // 获取访问权限选项
  getAccessLevelOptions() {
    return http.get('/o1/question_bank/get_access_level_options');
  },

  // 获取状态选项
  getStatusOptions() {
    return http.get('/o1/question_bank/get_status_options');
  },

  // 复制题库
  copy(id) {
    return http.post('/o1/question_bank/copy', { id });
  },

  // 更新题库统计
  updateStats(id) {
    return http.post('/o1/question_bank/update_stats', { id });
  },

  // 批量导入题库
  import(file) {
    const formData = new FormData();
    formData.append('file', file);
    return http.upload('/o1/question_bank/import', formData);
  },

  // 导出题库
  export(params = {}) {
    return http.post('/o1/question_bank/export', params, {
      responseType: 'blob'
    });
  }
};
